import { useState, useEffect } from 'react';

function useSimulationQuery(customerSimulationId: string) {
    const [query, setQuery] = useState({});

    useEffect(() => {
        if (customerSimulationId.length) {
            setQuery({
                measures: [
                    'SimulationTpp.count',
                    'SimulationTpp.matches',
                    'SimulationTpp.matchesAccept',
                    'SimulationTpp.matchesRejectRules'
                ],

                order: {
                    'SimulationTpp.matches': 'desc'
                },
                dimensions: ['SimulationTpp.rule', 'SimulationTpp.ruledesc'],
                timeDimensions: [],
                renewQuery: true,
                filters: [
                    {
                        member: 'SimulationTpp.simId',
                        operator: 'equals',
                        values: [customerSimulationId]
                    }
                ]
            });
        }
    }, [customerSimulationId]);

    return { query };
}

export default useSimulationQuery;
